<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">สร้างใบส่งคืนสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>

      <v-card class="mb-5" elevation="4" style="border-radius: 15px;">
        <v-card-text>
          <div class="mt-3 pa-4">
            <v-form ref="setting">
              <v-row>
                <!-- ข้อมูลทั่วไป -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/box.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">เลือกสินค้าที่ต้องการคืน</div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">สินค้าที่ต้องการคืน  <span class="required--text">*</span></label>
                      <v-autocomplete class="input-radius" color="#D6BFAF" :items="order" item-text="name" item-value="id" :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                      v-model="product_value" prepend-inner-icon="mdi-barcode-scan" label="" placeholder="กรุณาเลือกสินค้าที่ต้องการคืน" hide-details="auto"
                      outlined dense></v-autocomplete>
                  </v-form-group>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-5"  elevation="4" style="border-radius: 15px;">
        <v-card-text>
          <div class="mt-3 pa-4">
            <v-form ref="setting" @submit.prevent="saveData()">
              <v-row>
                <!-- ข้อมูลสินค้า -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/box.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">ข้อมูลสินค้า</div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12 pb-0">
                  <h3 class="breadcrumb_title_page">หมายเลขคำสั่งซื้อ : </h3>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th width="100" class="text-left">รายการสินค้า </th>
                          <th class="text-left"></th>
                          <th class="text-left">
                            ราคาต่อหน่วย
                          </th>
                          <th class="text-left">
                            หน่วยนับ
                          </th>
                          <th class="text-left">
                            จำนวน
                          </th>
                          <th class="text-left">
                            ราคารวม
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in desserts" :key="item.name" >
                          <td>
                            <div class="my-2">
                              <v-img class="preview" height="80" width="80" :lazy-src="item.picture" :src="item.picture"></v-img>
                            </div>
                          </td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.cost }}</td>
                          <td>{{ item.unit_name }}</td>
                          <td>
                            <div class="title-flex-center">
                              <v-btn class="mt-1" color="#D6BFAF" height="17px" width="17px"
                                style="border-radius: 5px;border-color:#D6BFAF;"
                                @click="subtractQuantity(item)" fab x-small dark outlined>
                                <v-icon>mdi-minus</v-icon>
                              </v-btn>
                              <span class="ml-2 mr-2"> {{ item.quantity }}</span>
                              <v-btn class="mt-1" color="#D6BFAF" height="17px" width="17px"
                                style="border-radius: 5px;border-color:#D6BFAF;" @click="addQuantity(item)" fab
                                x-small dark outlined>
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </div>  
                          </td>
                          <td>{{ item.total.toLocaleString() }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-row>
                <!-- ข้อมูลทั่วไป -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/box.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">สาเหตุการคืน</div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <v-radio-group v-model="refund_reason" row>
                      <v-radio label="ของมาผิด" color="#D6BFAF" :value="1"></v-radio>
                      <v-radio label="ชำรุด" color="#D6BFAF" :value="2"></v-radio>
                      <v-radio label="อื่น ๆ" color="#D6BFAF" :value="3"></v-radio>
                    </v-radio-group>
                  </v-form-group>
                </v-col>
                <v-col  cols="12 pt-0">
                  <label class="label_form_text pb-4"> กรุณาแนบรูปภาพสินค้าที่ต้องการส่งคืนจำนวน 2 ภาพ </label> 
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12" class="pt-0">
                  <v-form-group class="line-grid">
                    <label class="label_form_text pb-4"> <span class="required--text">กรุณาถ่ายภาพสินค้าบริเวร เลขล๊อตและวันหมดอายุ</span> <v-icon class="font-20 required--text">mdi-help-circle-outline</v-icon></label>
                    <v-file-input id="fileUpload_lot" accept="image/*" @change="onFileChange_picture_lot" prepend-icon=""
                      v-model="picture_lot" hide-input /> 
                    <v-img v-if="imagePreviewURL_lot !== null" :lazy-src="img_holder_cert" :src="imagePreviewURL_lot"
                      class="preview profile_img">
                      <v-btn elevation="4" class="mt-2 btn_edit_logo" @click="getFile_picture_lot" outlined color="#FEA06C"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn></v-img>
                    <v-img v-else :lazy-src="img_holder_cert" :src="img_holder_cert" class="preview profile_img">
                      <v-btn elevation="4" @click="getFile_picture_lot" class="mt-2 btn_edit_logo" outlined color="#FEA06C"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn></v-img>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12" class="pt-0">
                  <v-form-group class="line-grid">
                    <label class="label_form_text pb-4"> <span class="required--text">ภาพความผิดปกติของสินค้า </span> <v-icon class="font-20 required--text">mdi-help-circle-outline</v-icon> </label>
                    <v-file-input id="fileUpload_damage" accept="image/*" @change="onFileChange_picture_damage" prepend-icon=""
                      v-model="picture_damage" hide-input /> 
                    <v-img v-if="imagePreviewURL_damage !== null" @click="getFile_picture_damage" :lazy-src="img_holder_cert" :src="imagePreviewURL_damage"
                      class="preview profile_img">
                      <v-btn elevation="4" class="mt-2 btn_edit_logo" outlined color="#FEA06C"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn></v-img>
                    <v-img v-else :lazy-src="img_holder_cert" @click="getFile_picture_damage" :src="img_holder_cert" class="preview profile_img">
                      <v-btn elevation="4" class="mt-2 btn_edit_logo" outlined color="#FEA06C"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn></v-img>
                  </v-form-group>
                </v-col>  
              </v-row>

              <v-row>
                <!-- ข้อมูลระบบ POS -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/cashier_white.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">การคืนสินค้า</div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text pb-4">ท่านต้องการคืนสินค้าอย่างไร ? <span class="required--text">* </span> </label> 
                    <v-radio-group v-model="refund_send" row>
                      <v-radio label="ส่งคืนที่หน้าร้าน" color="#D6BFAF" :value="1"></v-radio>
                      <v-radio label="ส่งพัสดุ" color="#D6BFAF" :value="2"></v-radio>
                    </v-radio-group>
                  </v-form-group>
                </v-col>

                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12" class="pb-0">
                  <v-form-group>
                    <label class="label_form_text pb-4">วิธีการแก้ไขที่ท่านต้องการ ?  <span class="required--text">* </span> </label> 
                    <v-radio-group v-model="refund_fix" row>
                      <v-radio label="ส่งคืนสินค้าชิ้นใหม่"  color="#D6BFAF" :value="1" @change="onOptionChange"></v-radio>
                      <v-radio label="คืนเงิน" color="#D6BFAF" :value="2" @change="onOptionChange"></v-radio>
                    </v-radio-group>
                  </v-form-group>
                </v-col>

                <v-row class="pa-40" v-if="refund_fix == 2">
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12" class="pt-0">
                    <label class="label_form_text pb-4">ที่อยู่จัดส่ง </label> 
                  </v-col>

                  <v-col xs="12" sm="12" md="5" lg="5" xl="5" cols="12" >
                    <v-form-group>
                      <label class="label_form_text">ชื่อผู้รับ <span class="required--text">*</span></label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-storefront"
                        hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" v-model="refund_fix_name"
                        placeholder="ชื่อสาขา" single-line outlined dense required></v-text-field>
                    </v-form-group>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col xs="12" sm="12" md="5" lg="5" xl="5" cols="12">
                    <v-form-group>
                      <label class="label_form_text">เบอร์โทร <span class="required--text">*</span></label>
                      <v-otp-input type="number" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                        v-model="refund_fix_tel" length="10" @keypress="isNumber($event, telephone)" @paste="isPaste($event)"
                        placeholder="x" single-line outlined dense required></v-otp-input>
                    </v-form-group>
                  </v-col>
                  <v-spacer></v-spacer>
                
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12" class="pt-0">
                    <v-form-group>
                      <label class="label_form_text">ที่อยู่ </label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto"
                        v-model="refund_fix_address" placeholder="กรุณากรอกที่อยู่" single-line outlined dense
                        required></v-text-field>
                    </v-form-group>
                  </v-col>

                  <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                    <v-form-group>
                      <label class="label_form_text">ตำบล </label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto"
                        v-model="tumbon" placeholder="กรุณากรอกตำบล" single-line outlined dense
                        required></v-text-field>
                    </v-form-group>
                  </v-col>
                  <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                    <v-form-group>
                      <label class="label_form_text">อำเภอ </label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto"
                        v-model="amphor" placeholder="กรุณากรอกอำเภอ" single-line outlined dense
                        required></v-text-field>
                    </v-form-group>
                  </v-col>
                  <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                    <v-form-group>
                      <label class="label_form_text">จังหวัด </label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto"
                        v-model="province" placeholder="กรุณากรอกจังหวัด" single-line outlined dense
                        required></v-text-field>
                    </v-form-group>
                  </v-col>
                  <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                    <v-form-group>
                      <label class="label_form_text">รหัสไปรษณีย์ </label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto"
                        v-model="zipcode" placeholder="กรุณากรอกรหัสไปรษณีย์" single-line outlined dense
                        required></v-text-field>
                    </v-form-group>
                  </v-col>

                </v-row>

                <!-- <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12" class="pt-0">
                  <v-form-group> -->
                    <!-- <label class="label_form_text pb-4">วิธีการแก้ไขที่ท่านต้องการ ?  <span class="required--text">* </span> </label>  -->
                    <!-- <v-radio-group v-model="selectedOption" row>
                      <v-radio label="คืนเงิน" color="#D6BFAF" :value="2" @change="onOptionChange"></v-radio>
                    </v-radio-group>
                  </v-form-group>
                </v-col> -->

                <!-- <v-row class="pa-40" v-if="refund_fix == 1">
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12" class="pt-0">
                    <label class="label_form_text pb-4">ช่องทางการชำระเงิน </label> 
                  </v-col>

                  <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" >
                    <v-form-group>
                      <label class="label_form_text">ชื่อบัญชี <span class="required--text">*</span></label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-storefront"
                        hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" v-model="refund_fix_bank_name"
                        placeholder="ชื่อบัญชี" single-line outlined dense required></v-text-field>
                    </v-form-group>
                  </v-col>

                  <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12"></v-col>

                  <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="pt-0">
                    <v-form-group>
                      <label class="label_form_text">ธนาคาร <span class="required--text">*</span> </label>
                      <v-text-field color="#D6BFAF" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto"
                        v-model="refund_fix_bank_account_name" placeholder="กรุณากรอกธนาคาร" single-line outlined dense
                        required></v-text-field>
                    </v-form-group>
                  </v-col>

                  <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12"  class="pt-0">
                    <v-form-group>
                      <label class="label_form_text">เลขที่บัญชี <span class="required--text">*</span></label>
                      <v-text-field color="#D6BFAF" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto"
                        v-model="refund_fix_bank_number" placeholder="กรุณากรอกตเลขที่บัญชี" single-line outlined dense
                        required></v-text-field>
                    </v-form-group>
                  </v-col>

                </v-row> -->

                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12" class="pt-0">
                  <v-container class="px-0 pt-0 title-flex-baseline" fluid>
                    <v-checkbox class="mt-0" v-model="checkbox"></v-checkbox>
                    <span> ฉันได้อ่านและยอมรับใน <a @click="dialog_detail();"> นโยบายการคืนสินค้า </a> ของฟาร์มาแคร์ พลัส </span>
                  </v-container>
                </v-col>

                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="title_page ma-3" style="justify-content:center;">
                    <v-btn type="submit" class="btn_add_data" elevation="4" large>ส่งแบบฟอร์มคืนสินค้า</v-btn>
                  </div>
                </v-col>
              </v-row>
              
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!-- return dialog นโยบาย -->
    <v-dialog v-model="return_dialog_detail" persistent max-width="650">
        <v-card>
            <div class="d-flex justify-space-between">
                <v-card-title>
                    <b>นโยบายการคืนสินค้า</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="return_dialog_detail = false">
                    <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
            </div>
            <v-card-text>
                <v-row>
                    <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                        <!-- นโยบาย -->
                       1. นโยบายการคืนสินค้า
                      เมื่อท่านได้รับสินค้าที่สั่งซื้อไปแล้ว โปรดรักษาสภาพสินค้าให้อยู่ในสภาพเดิมมากที่สุด ทั้งตัวสินค้าและบรรจุภัณฑ์

                      บริษัทฯ มีนโยบายการคืนสินค้าสำหรับทุกๆการซื้อสินค้าผ่านร้านค้าออนไลน์ โฟร์โมสต์ เดลิเวอรี่ (https://homedelivery.foremostthailand.com/th) ให้แก่ลูกค้าทุกท่าน โดยลูกค้าสามารถคืนสินค้าได้ภายใน 7 (เจ็ด) วัน* หลังจากที่ได้รับสินค้า ขึ้นอยู่กับคำอธิบายในหน้ารายละเอียดสินค้า ระยะเวลาการคืนสินค้าจะเริ่มนับตั้งแต่ลูกค้าได้รับสถานะว่าสินค้าได้ถูกจัดส่งถึงที่อยู่ลูกค้าเรียบร้อยแล้ว (นับรวมวันเสาร์ อาทิตย์ และวันหยุดนักขัตฤกษ์) ลูกค้าสามารถตรวจสอบระยะเวลาคืนสินค้าจากสัญลักษณ์ที่แสดงในหน้ารายละเอียดสินค้า

                      (* อ้างอิงตามพระราชบัญญัติขายตรงและตลาดแบบตรง พ.ศ. 2545)

                      ลูกค้าสามารถเลือกวิธีปฏิบัติในการคืนสินค้า ได้ 2 ตัวเลือก ได้แก่

                      “คืนสินค้าเพื่อรับเงินคืน” หมายถึง (1) ลูกค้าต้องการส่งคืนสินค้าที่ซื้อไปยังบริษัทฯ และ (2) ต้องการจะรับเงินคืนสำหรับธุรกรรมดังกล่าว

                      “การเปลี่ยนสินค้า” หมายถึง (1) ลูกค้าต้องการคืนสินค้าที่ซื้อไปยังบริษัทฯ และ (2) ต้องจะรับสินค้าใหม่ที่เป็นชนิดและแบบเดียวกันกับที่ลูกค้าสั่งซื้อ โดยไม่สามารถเปลี่ยนสินค้าเป็นรสชาติหรือขนาดบรรจุอื่นให้ลูกค้าได้ หากลูกค้าต้องการเปลี่ยนสินค้าเป็นรสชาติหรือขนาดบรรจุอื่น ลูกค้าต้องคืนสินค้าและสั่งใหม่เท่านั้น

                      เงื่อนไขในการคืนสินค้าเพื่อรับเงินคืนและการเปลี่ยนสินค้า

                      บริษัทฯจะรับคืนสินค้าเพื่อคืนเงินให้กับลูกค้า  และเปลี่ยนสินค้าให้กับลูกค้าที่สั่งซื้อสินค้าผ่านร้านค้าออนไลน์ โฟร์โมสต์ เดลิเวอรี่ (https://homedelivery.foremostthailand.com/th) เฉพาะในกรณี ดังต่อไปนี้

                      “ได้รับสินค้าผิด” หมายถึง สินค้าที่ลูกค้าได้รับไม่ถูกต้องตามรายการที่สั่งซื้อของลูกค้า ซึ่งในกรณีคืนสินค้าเนื่องจากได้รับสินค้าผิดนี้ สินค้าที่รับคืนจะต้องอยู่ในสภาพเดิม บรรจุภัณฑ์ไม่ถูกแกะหรือฉีกขาด

                      “สินค้าถูกแกะ ฉีก,ขาด” หมายถึง สินค้าที่ลูกค้าได้รับมีสภาพลักษณะภายนอกภายในชำรุดเสียหาย มีร่องรอยการแกะ ฉีกขาด จากบรรจุภัณฑ์ที่ห่อหุ้มสินค้า

                      “สินค้าแตก, บวม” หมายถึง สินค้าและบรรจุภัณฑ์ที่ห่อหุ้มสินค้าที่ลูกค้าได้รับมีลักษณะบวม พอง แตก

                      “สินค้ามีปัญหาคุณภาพ” หมายถึง สินค้าที่ลูกค้าได้รับมีลักษณะ รสชาติ กลิ่น สี ผิดไปจากเดิม

                      “สินค้าหมดอายุ” หมายถึง สินค้าที่ลูกค้าได้รับผ่านวันรับประกัน หรือหมดอายุแล้ว

                      “ลูกค้าเปลี่ยนใจ” หมายถึง ลูกค้าตัดสินใจคืนสินค้าด้วยเหตุผลอื่นนอกเหนือจากที่ระบุข้างต้น บริษัทฯ ขอสงวนสิทธิ์ในการรับคืนสินค้า /คืนเงิน /เปลี่ยนสินค้า เนื่องจาก “ลูกค้าเปลี่ยนใจ”

                      บริษัทฯจะไม่รับคืนหรือเปลี่ยนสินค้า ในกรณีดังต่อไปนี้

                      – ผลิตภัณฑ์มีรูปทรงที่เปลี่ยนไปจากตอนแจ้งเข้ามายังบริษัท

                      – สินค้าที่ไม่ได้ซื้อจาก Foremost Home Delivery

                      – สินค้าที่ทำการแกะ ฉีก เปิด หรือใช้แล้ว

                      – สินค้าที่มีความเสียหาย หรือความเสียหายอันเนื่องมาจากการแพ๊คสินค้าส่งคืนของลูกค้า

                      – ลูกค้าไม่ได้แจ้งคำร้องและส่งสินค้ากลับคืนภายใน 7 วัน หลังจากวันที่ได้รับสินค้า

                      – สินค้าที่เป็นของแถมหรือสินค้าร่วมรายการพิเศษแบบมีเงื่อนไข

                      หมายเหตุ

                      ลูกค้าเป็นผู้รับผิดชอบค่าใช้จ่ายในการส่งสินค้าคืนให้กับบริษัทฯ เว้นแต่กรณีที่การคืนสินค้าเกิดขึ้นจากข้อผิดพลาดของบริษัทฯ เช่น ส่งสินค้าไม่ตรงตามรายการที่ลูกค้าสั่งซื้อ หรือสินค้าที่ลูกค้าได้รับมีลักษณะผิดไปจากสภาพและลักษณะของสินค้าโดยปกติที่ลูกค้าจะได้รับ (ดูภาพตัวอย่าง)

                      กรุณาส่งคืนสินค้าให้กับบริษัทฯให้เรียบร้อยและด้วยความระมัดระวัง เพื่อให้มั่นใจว่าสินค้าเหล่านั้นถูกส่งกลับมาถึงในสภาพปกติ ไม่ชำรุดเสียหาย

                      ระยะเวลาการดำเนินการ

                      ลูกค้าที่มีความประสงค์จะคืนสินค้าเพื่อขอรับเงินคืน หรือเปลี่ยนสินค้าจะต้องแจ้งคำร้อง ภายใน 7 วันนับแต่วันที่ได้รับมอบสินค้าในกรณีขอรับเงินคืน บริษัทจะคืนเงินให้กับลูกค้าภายใน 15 วันทำการ นับจากวันที่รับคำร้องจากลูกค้า สำหรับการขอเปลี่ยนสินค้า บริษัทฯจะใช้เวลาในการดำเนินการไม่เกิน 30 วันทำการ (ในบางกรณีอาจใช้เวลามากกว่า) นับจากวันที่รับสินค้าคืนจากลูกค้า ในการติดต่อกับบริษัทเพื่อแจ้งคำร้อง หรือสอบถามความคืบหน้าในการดำเนินการ ลูกค้าสามารถติดต่อหรือสอบถามได้ที่ศูนย์บริการช่วยเหลือลูกค้าออนไลน์, หรือ ส่งข้อความแชทในเพจ Facebook Foremost Thailand, หรือ ศูนย์ข้อมูลผู้บริโภคโฟร์โมสต์ เบอร์โทรศัพท์ 02 6201980 (บริการ 24 ชั่วโมง), หรือ อีเมลล์ CallCenter.foremost@frieslandcampina.com

                      ข้อสงวนสิทธิ์

                      บริษัทฯขอสงวนสิทธิ์ในการที่จะยกเลิกรายการสั่งซื้อและคืนค่าสินค้าและบริการทั้งหมดแก่ลูกค้า เพื่อระงับข้อขัดแย้งต่างๆ

                      บริษัทฯ ขอสงวนสิทธิ์ในการปฏิเสธการคืนสินค้าเพื่อรับเงินคืน คืนเงิน หรือการเปลี่ยนสินค้าที่ไม่ตรงตามข้อกำหนดและเงื่อนไขที่ระบุไว้ในนโยบายการคืนสินค้านี้

                      บริษัทฯขอสงวนสิทธิ์ในการปรับเปลี่ยน/ปรับปรุง/แก้ไข เงื่อนไขนโยบายคืนสินค้านี้ โดยมิต้องแจ้งให้ทราบล่วงหน้า

                      <br>
                      <br>

                      2. นโยบายการคืนเงิน
                      ช่องทางการคืนเงิน

                      ระยะเวลาในการคืนเงิน

                      โอนเงินเข้าบัญชีลูกค้า

                      ไม่เกิน 15 วันทำการ นับแต่วันที่รับคำร้องจากลูกค้า

                      หมายเหตุ

                      “วันทำการ” หมายถึง วันจันทร์-ศุกร์ ไม่รวมวันหยุดเสาร์ อาทิตย์ และนักขัตฤกษ์ โดยระยะเวลาการคืนเงินอาจมากกว่าระยะที่กำหนดในตารางข้างต้น  ซึ่งขึ้นอยู่กับขั้นตอนต่างๆ ของธนาคารของบริษัทฯ และของลูกค้า

                      ข้อกำหนดเพิ่มเติมสำหรับการคืนเงิน

                      บริษัทฯ อาจติดต่อลูกค้าและขอเอกสารหลักฐานเพิ่มเติม เพื่ออำนวยความสะดวกในกระบวนการคืนเงิน หากลูกค้าปฏิเสธที่จะให้ข้อมูลเกี่ยวกับบัญชีธนาคารของลูกค้า หรือ ให้เอกสารหลักฐานที่เกี่ยวข้องกับการยื่นคำร้องบริการหลังการขายเพื่อคืนเงิน บริษัทฯ ขอสงวนสิทธิ์ในการไม่อนุมัติกระบวนการคืนเงินดังกล่าว

                      <br>
                      <br>

                      3. นโยบายการรับประกันสินค้า
                      บริษัทฯรับรองและรับประกันว่าสินค้าที่ขายให้กับผู้บริโภคผ่านร้านออนไลน์ โฟร์โมสต์ โฮม เดลิเวอรี่ (https://homedelivery.foremostthailand.com/th)

                      1) เป็นไปตามสเปค เมื่อส่งมอบ,

                      2) ผลิตขึ้นตามหลักเกณฑ์และวิธีการที่ดีในการผลิตอาหาร,

                      3) ผลิตขึ้นภายใต้ระบบการประกันคุณภาพเพื่อให้มั่นใจว่าสอดคล้องกับการรับรองข้างต้น และ

                      4) ปราศจากการรอนสิทธิทั้งปวงเมื่อส่งมอบ

                      บริษัทฯมีความตั้งใจและตั้งมั่นอยู่บนพื้นฐานของสิทธิ์ของผู้บริโภคและพร้อมจะปฎิบัติเพื่อให้เกิดความถูกต้อง เท่าเทียม โปร่งใส และใส่ใจกับลูกค้าทุกๆท่าน รวมถึงการคัดสรรในการเลือกสินค้าและขั้นตอนของการบริการตอบโจทย์ลูกค้าที่สุด ในกรณีหากเกิดมีข้อขัดแย้ง บริษัทจะพยายามอย่างที่สุดภายใต้ขอบเขตหน้าที่และความรับผิดชอบที่ทำได้ เพื่อแก้ไข/ชดเชย ปัญหาที่เกิดขึ้นเหล่านั้น 
                    </v-col>
                </v-row>
            </v-card-text>
            <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="button" class="btn_add_data" elevation="4" large>ยืนยัน</v-btn>
            </v-card-actions> -->
        </v-card>
    </v-dialog>

  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_profile.png";
import img_holder_document from "@/assets/arin_assets/image_document.png";
import img_holder_cert from "@/assets/arin_assets/image_sun_color.png";
import { HTTP_ARIN } from "@/axios_arin";
import { HTTP } from "@/axios";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Manage_website",
  data() {
    return {
      loading_page: false,
      return_dialog_detail: false,
      img_holder: img_holder,
      img_holder_document: img_holder_document,
      img_holder_cert: img_holder_cert,
      imagePreviewURL_lot: null,
      imagePreviewURL_damage: null,
      selectedOption: '1',
      checkbox: true,
      product_value: null,
      refund_reason: 1,
      refund_send: 1,
      refund_fix: 1,
      refund_fix_name: null,
      refund_fix_tel: null,
      refund_fix_address: null,
      refund_fix_sub_address: null,
      refund_fix_bank_account_name: null,
      refund_fix_bank_name: null,
      refund_fix_bank_number: null,
      tumbon: null,
      amphor: null,
      province: null,
      zipcode: null,

      input_set: {
        branch_select: '',
        telephone: '',
        tax_number: '',
        address: '',
        address_set: '',
        plate_color: '#D6BFAF',
        vat_radio: '',
        charge_credit: true,
        credit: '',
        system_logo: null,
        receipt_logo: null,
        receipt_number: '',
        receipt_note: '',
      }, 
      desserts: [],
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'ออกใบสั่งซื้อ',
          disabled: false,
        },
        {
          text: 'คำสั่งซื้อของฉัน',
          disabled: false,
        },
        {
          text: 'สร้างใบส่งคืนสินค้า',
          disabled: false,
          href: '#',
        },
      ],
      order: [],
    }
  },
  methods: {
    async saveData(){
              // ตรวจสอบว่ามีรายการสินค้าใน desserts หรือไม่
        if (!this.desserts.length) {
          Swal.fire({
            icon: 'error',
            text: 'กรุณาเลือกสินค้าที่ต้องการคืนก่อนบันทึก'
          });
          return;
        }
        // if (!this.picture_lot) {
        //   Swal.fire({
        //     icon: 'error',
        //     text: 'กรุณาอัพโหลดรูปภาพสินค้าบริเวณเลขล๊อตและวันหมดอายุ'
        //   });
        //   return;
        // }
        // if (!this.picture_damage) {
        //   Swal.fire({
        //     icon: 'error',
        //     text: 'กรุณาอัพโหลดรูปภาพความผิดปกติของสินค้า'
        //   });
        //   return;
        // }
        if(this.$refs.setting.validate()){
            let data = new FormData
            data.append('user_type', this.$store.state.store_arin.user_data.customer_type)
            data.append('user_id', this.$store.state.store_arin.user_data.id)
            data.append('user_name', this.$store.state.store_arin.user_data.name)
            data.append('order_id', this.desserts[0].order_id)
            data.append('order_code', this.desserts[0].order_code)
            data.append('refund_reason', this.refund_reason)
            data.append('refund_reason_text', '')
            // ส่งรูปถ้ามีเท่านั้น
            if (this.picture_lot) data.append('picture_lot', this.picture_lot)
            if (this.picture_damage) data.append('picture_damage', this.picture_damage)
            data.append('refund_send', this.refund_send)
            data.append('refund_fix', this.refund_fix)
            data.append('refund_fix_name', this.refund_fix_name)
            data.append('refund_fix_tel', this.refund_fix_tel)
            data.append('refund_fix_address', this.refund_fix_address)
            data.append('refund_fix_sub_address', `${this.tumbon} ${this.amphor} ${this.province} ${this.zipcode}`)
            data.append('refund_fix_bank_account_name', this.refund_fix_bank_account_name)
            data.append('refund_fix_bank_name', this.refund_fix_bank_name)
            data.append('refund_fix_bank_number', this.refund_fix_bank_number)
            data.append('order_stock_id', this.desserts[0].id)
            data.append('lot_no', this.desserts[0].lot_no)
            data.append('qty', this.desserts[0].quantity)
            data.append('cost', this.desserts[0].cost)
            this.loading_page = true
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            await  HTTP.post('/create/refund/from/arin', data, config).then((res) => {
                if (res.data.successful === true) {
                  let timerInterval
        Swal.fire({
          title: 'เสร็จสิ้น',
          text: 'เพิ่มข้อมูลรอบนับสต๊อกเรียบร้อยแล้ว',
          icon: 'success',
          timer: 2000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading()
            timerInterval = setInterval(() => { }, 100)
          },
          willClose: () => {
            clearInterval(timerInterval)
          }
          }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                        this.$router.push("/arin/pos/returnproductlist");
                    }
                })
                }
            })
        }
    },
    addItem(){
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/refund/get/product/'+this.product_value, config).then((res) => {
        if (res.data.successful === true) {
          this.desserts.push({
            ...res.data.order,
            // quantity: 1
          });
        }
      })
    },
    getFile_picture_lot() {
      let fileUpload = document.getElementById('fileUpload_lot')
      if (fileUpload != null) {
        fileUpload.click()
      }
    },
    getFile_picture_damage() {
      let fileUpload = document.getElementById('fileUpload_damage')
      if (fileUpload != null) {
        fileUpload.click()
      }
    },
    onFileChange_picture_lot(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL_lot = null
          })
        } else {
          if (file) {
            this.imagePreviewURL_lot = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL_lot = null
          }
        }
      } else {
        this.imagePreviewURL_lot = null
      }
    },
    onFileChange_picture_damage(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL_damage = null            
          })
        } else {
          if (file) {
            this.imagePreviewURL_damage = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL_damage = null            
          }
        }
      } else {
        this.imagePreviewURL_damage = null       
      }
    },
    addQuantity(item) {
      item.quantity++;
      item.total = item.quantity * item.cost;
    },
    subtractQuantity(item) {
      item.quantity--;
      item.total = item.quantity * item.cost;
    },
    dialog_detail() {
            this.return_dialog_detail = true;
    },
    onOptionChange() {
      // do something here when the radio button changes
    },
    retrunProductDetail() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/refund/get/product/list', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.order = res.data.order;
          console.log(this.order);
        }
      })
    }
  },
  mounted() {
    this.retrunProductDetail();
  },
  watch:{
    product_value(){
      this.addItem()
    }
  }
}
</script>

<style scoped>

.pa-40
{
  padding: 40px;
  padding-top: 10px;
  padding-bottom: 15px;
}

.line-grid{
  display: inline-grid;
}
.font-20
{
  font-size: 20px;
}
.title-flex-center
{
  display: flex;
  align-items: center;
}

.title-flex-baseline
{
  display: flex;
  align-items: baseline;
  font-size: 16px;
}

.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.v-tab {
  font-size: 16px;
  font-weight: 500;
}

.v-tab.v-tab--active {
  font-size: 16px;
  font-weight: 700;
}

.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.title_form_main {
  background: #D6BFAF;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.title_form_header {
  background: #D6BFAF;
  padding: 4px 10px 4px 10px;
  /* opacity: 0.35; */
  border: 1px solid #D6BFAF;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  border-radius: 0px 30px 30px 0px;

}

.title_form_header_text {
  color: #616A6B;
}


.logo_timeline {
  padding: 6px;
}


.logo_timeline>img {
  max-width: 25px;
}

.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}



.v-otp-input .v-input {
  padding: 10px !important
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-around;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: 55px;
  left: 150px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
}

.preview.profile_img {
  max-width: 300px;
  border-radius: 30px;
}

.btn_edit_logo {
  border-radius: 10px;
  background-color: #FFF;
  position: absolute;
  top: 8px;
  right: 16px;
}


.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin>img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.table-data-img-center {
  display: flex;
  
}

.v-data-table__wrapper>>>span {
  font-size: 50px;
}

.title_form {
  display: flex;
  margin-top: 2px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616A6B !important;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 15%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {

  .title_page h4.breadcrumb_title_page,
  .v-tab {
    font-size: 14px !important;
  }

  .v-timeline-item__divider {
    display: none !important;
  }

  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 50%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 30%;
  }
}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 30%;
  }
}
</style>
